/* TUM dosya kendi kapsaminda calisir.
   Sebep: Shopify bu dosyalari klasik <script> olarak yukler, hepsi ayni
   global kapsami paylasir. finder.js de MARKA_GENELI ve normalize
   tanimliyor; sarmalayici olmadan "already been declared" hatasi
   veriyor ve bu dosya HIC calismiyordu. */
(function () {
  'use strict';

  /* Motosiklet secici SONUC sayfasi.

     Adresteki ?marka=..&model=.. okunur, moto-index.json'dan urun handle'lari
     bulunur ve KOLEKSIYON sayfasiyla AYNI kart isaretlemesi basilir
     (snippets/product-card.liquid birebir taklit edilir).

     Neden istemci tarafinda: Liquid rastgele sorgu parametresi okuyamaz.
     Kabuk (baslik bandi + izgara) sunucudan gelir, kartlar burada doldurulur. */

  /* snippets/upper.liquid ile AYNI liste. Snippet degisirse burasi da guncellenir.
     .card__title CSS'te text-transform:none oldugu icin donusum burada yapilir;
     duz toUpperCase() Turkce kuralini uygulayip yabanci kelimelerde noktali I
     uretiyor (GRIPPATCH -> yanlis sonuc). */
  const UPPER_DUZELT = [["STREETFİGHTER", "STREETFIGHTER"], ["AVAİLABİLİTY", "AVAILABILITY"], ["MULTİSTRADA", "MULTISTRADA"], ["PROTECTİON", "PROTECTION"], ["GRİPPATCH", "GRIPPATCH"], ["UNİVERSAL", "UNIVERSAL"], ["PANİGALE", "PANIGALE"], ["TİTANİUM", "TITANIUM"], ["SHİPPİNG", "SHIPPING"], ["ULTİMATE", "ULTIMATE"], ["KAWASAKİ", "KAWASAKI"], ["PREMİUM", "PREMIUM"], ["CLASSİC", "CLASSIC"], ["SETTİNG", "SETTING"], ["APRİLLA", "APRILLA"], ["COOLİNG", "COOLING"], ["LİMİTED", "LIMITED"], ["EDİTİON", "EDITION"], ["SPECİAL", "SPECIAL"], ["TRİUMPH", "TRIUMPH"], ["APRİLİA", "APRILIA"], ["BENELLİ", "BENELLI"], ["DOMİNAR", "DOMINAR"], ["STİCKER", "STICKER"], ["MONDİAL", "MONDIAL"], ["PİAGGİO", "PIAGGIO"], ["TURİSMO", "TURISMO"], ["AİRTAG", "AIRTAG"], ["AFRİCA", "AFRICA"], ["RACİNG", "RACING"], ["DESİGN", "DESIGN"], ["SUZUKİ", "SUZUKI"], ["SİLVER", "SILVER"], ["LİQUİD", "LIQUID"], ["DİAVEL", "DIAVEL"], ["DUCATİ", "DUCATI"], ["ACTİVA", "ACTIVA"], ["NİNJA", "NINJA"], ["PRİCE", "PRICE"], ["GRİP", "GRIP"], ["SİZE", "SIZE"], ["TWİN", "TWIN"], ["DİO", "DIO"]];

  function upper(metin) {
    let s = String(metin || '').replace(/i/g, '\u0130').toUpperCase();
    for (const c of UPPER_DUZELT) s = s.split(c[0]).join(c[1]);
    return s;
  }

  const para = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const fiyat = (k) => (typeof k === 'number' ? para.format(k / 100) + ' TL' : '');
  const MARKA_GENELI = 'Universal (marka geneli)';

  function normalize(data) {
    if (!data || typeof data !== 'object') return {};
    const duzelt = (l) =>
      (Array.isArray(l) ? l : []).map((m) =>
        typeof m === 'string'
          ? { ad: m, urunler: [] }
          : { ad: m.ad || '', urunler: Array.isArray(m.urunler) ? m.urunler : [], genelYok: m.genelYok === true }
      );
    const out = {};
    if (Array.isArray(data.markalar)) {
      data.markalar.forEach((m) => {
        if (m && m.ad) out[m.ad] = { modeller: duzelt(m.modeller) };
      });
      return out;
    }
    Object.keys(data).forEach((ad) => {
      if (Array.isArray(data[ad])) out[ad] = { modeller: duzelt(data[ad]) };
    });
    return out;
  }

  /* finder.js'teki handleBul ile ayni kural: once modele ozel, sonra marka geneli */
  function urunBul(index, marka, modelAd) {
    const b = index[marka];
    if (!b) return [];
    const gm = (b.modeller || []).find((x) => x.ad === MARKA_GENELI);
    const genel = gm ? gm.urunler.slice() : [];
    if (modelAd && modelAd !== MARKA_GENELI) {
      const m = (b.modeller || []).find((x) => x.ad === modelAd);
      const ozel = m ? m.urunler.slice() : [];
      if (m && m.genelYok) return ozel;
      return ozel.concat(genel.filter((h) => ozel.indexOf(h) < 0));
    }
    const gorulen = new Set();
    (b.modeller || []).forEach((m) => {
      if (m.ad !== MARKA_GENELI) m.urunler.forEach((h) => gorulen.add(h));
    });
    const ozel = [...gorulen];
    return ozel.concat(genel.filter((h) => ozel.indexOf(h) < 0));
  }

  /* product-card.liquid ile ayni isaretleme */
  function kart(u, ayar) {
    const satilik = u.available !== false;
    const indirim = typeof u.compare_at_price === 'number' && u.compare_at_price > u.price;
    const olcu = (yol, w) => (yol ? yol.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2') : '');
    const ana = olcu(u.featured_image || '', 700);
    const anaKucuk = olcu(u.featured_image || '', 350);
    const ikinci = olcu((u.images && u.images[1]) || '', 700);

    const el = document.createElement('article');
    el.className = 'card' + (satilik ? '' : ' card--out');
    el.style.setProperty('--card-ratio', ayar.ratio);

    const bayrak =
      (indirim && satilik
        ? '<span class="badge badge--orange">-' +
          Math.round(((u.compare_at_price - u.price) * 100) / u.compare_at_price) +
          '%</span>'
        : '') + (satilik ? '' : '<span class="badge badge--out">' + ayar.tukendi + '</span>');

    el.innerHTML =
      '<a class="card__media" href="' + u.url + '" tabindex="-1" aria-hidden="true">' +
        (ana
          ? '<img class="card__img card__img--main" src="' + ana +
            '" srcset="' + anaKucuk + ' 350w, ' + ana + ' 700w"' +
            ' sizes="(min-width: 990px) 25vw, 45vw" alt="" loading="lazy" width="700" height="700">'
          : '') +
        (ayar.ikinci && ikinci
          ? '<img class="card__img card__img--alt" src="' + ikinci + '" alt="" loading="lazy" width="700" height="700">'
          : '') +
        '<div class="card__flags">' + bayrak + '</div>' +
      '</a>' +
      '<div class="card__body">' +
        (u.vendor ? '<span class="card__vendor"></span>' : '') +
        '<h3 class="card__title"><a href="' + u.url + '"></a></h3>' +
        '<div class="card__foot">' +
          '<span class="price' + (indirim ? ' price--sale' : '') + '">' + fiyat(u.price) +
            (indirim ? '<del>' + fiyat(u.compare_at_price) + '</del>' : '') +
          '</span>' +
        '</div>' +
      '</div>';

    if (u.vendor) el.querySelector('.card__vendor').textContent = upper(u.vendor);
    el.querySelector('.card__title a').textContent = upper(u.title || '');
    return el;
  }

  function init() {
    const root = document.querySelector('[data-moto-sonuc]');
    if (!root || root.dataset.hazir === '1') return;
    root.dataset.hazir = '1';

    const grid = root.querySelector('[data-moto-grid]');
    const baslik = root.querySelector('[data-moto-baslik]');
    const kirinti = root.querySelector('[data-moto-kirinti]');
    const adet = root.querySelector('[data-moto-adet]');
    const bos = root.querySelector('[data-moto-bos]');
    const ayar = {
      ratio: root.dataset.ratio || '1 / 1',
      ikinci: root.dataset.ikinci === 'true',
      tukendi: root.dataset.tukendi || '',
    };

    let q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { q = null; }
    const marka = q ? q.get('marka') : null;
    const modelAd = q ? q.get('model') || '' : '';
    const ad = marka ? (modelAd ? marka + ' ' + modelAd : marka) : '';

    if (ad) {
      if (baslik) baslik.textContent = upper(ad);
      if (kirinti) kirinti.textContent = upper(ad);
    }
    /* Adres parametresiz: ziyaretci henuz secim yapmadi. Secici hemen yukarida
       oldugu icin ayrica bir yonlendirme kutusu gosterilmez. */
    if (!marka) return;

    fetch(root.dataset.index, { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
      .then((data) => {
        const handles = urunBul(normalize(data), marka, modelAd);
        if (!handles.length) {
          if (bos) { bos.hidden = false; bos.style.display = ''; }
          return;
        }
        return Promise.all(
          handles.map((h) =>
            fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
              .then((r) => (r.ok ? r.json() : null))
              .catch(() => null)
          )
        ).then((liste) => {
          const gecerli = liste.filter(Boolean);
          /* koleksiyondaki siralama: gorselli+satilik -> gorselsiz -> tukenen */
          const puan = (u) => (u.available === false ? 2 : u.featured_image ? 0 : 1);
          gecerli.sort((a, b) => puan(a) - puan(b));
          gecerli.forEach((u) => grid.appendChild(kart(u, ayar)));
          if (adet) adet.textContent = gecerli.length + ' \u00fcr\u00fcn';
          if (!gecerli.length && bos) { bos.hidden = false; bos.style.display = ''; }
        });
      })
      .catch(() => {
        if (bos) { bos.hidden = false; bos.style.display = ''; }
      });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
  document.addEventListener('shopify:section:load', init);

})();
